<template>
<div class="page_art page_iteminfo page_park">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
        <div class="jiangren">
            <div class="con" v-for="(item,index) in dataList" :key="index">
                <div class="con_info clearfix">
                    <div class="thumb f-l">
                        <img :src="item.park_thumb ? ( $publicData.withHttpStart(item.park_thumb) ? item.park_thumb : imageUrl+item.park_thumb) : $publicData.defaultTouxiang" alt="" class="">
                    </div>
                    <div :class="item.user_level ? 'f-l con_info_r' : 'f-l con_info_r flexcenter'">
                        <div class="name slh_s">{{ item.park_name }}</div>
                        <div class="tag slh_s" v-if="item.user_level">{{ item.user_level }}</div>
                    </div>
                </div>
                <div class="park">
                    <div class="jifen" @click="goJifenList(item)">剩余积分：{{ item.user_score }}</div>
                    <div class="guize" @click="goRankRule(item)">等级规则</div>
                </div>
            </div>
        </div>
    </van-list>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            pages: {
                page: 1,
                size: 10
			},
			loading: true,
			finished: false,
			dataList: []
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '园区积分'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
        }
    },
    methods: {
        // 园区列表
        getData() {
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
			}
			this.$api.park.parkRole(params).then(res=>{
				if(res.code == 200){
					var list = []
					list = res.result.list
					if(list.length != 0){
						for(var i in list){
							this.dataList.push(list[i])
						}
						this.pages.page++
						this.loading = false
					}else{
						this.finished = true
					}
				}else{
					this.finished = true
				}
				
			})
        },
        // 积分记录
        goJifenList(item) {
            this.$router.push({
				path: '/park/jifen',
				query: {
					park_uuid: item.park_uuid,
					score: item.user_score
				}
            })
        },
        // 等级规则
        goRankRule(item) {
            this.$router.push({
				path: '/park/rank',
				query: {
					park_uuid: item.park_uuid
				}
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
